export const RCFIcon = () => {
  return (
    <svg
      width="29"
      height="26"
      viewBox="0 0 29 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6758 18.2695H18.27V23.8638"
        stroke="#08172B"
        strokeWidth="2.97727"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.6468 10.3514C24.8495 7.04244 24.1161 4.93021 22.2672 3.08411C19.0897 -0.09623 12.2185 1.62261 6.92077 6.92037C1.62301 12.2181 -0.0958284 19.0893 3.08311 22.2682C6.19771 25.3814 12.8549 23.7968 18.1037 18.7508"
        stroke="#08172B"
        strokeWidth="2.97727"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7041 11.3361C20.7041 12.1197 21.0154 12.8712 21.5695 13.4254C22.1236 13.9795 22.8752 14.2908 23.6588 14.2908C24.4425 14.2908 25.194 13.9795 25.7481 13.4254C26.3022 12.8712 26.6135 12.1197 26.6135 11.3361C26.6135 10.5524 26.3022 9.80088 25.7481 9.24676C25.194 8.69265 24.4425 8.38135 23.6588 8.38135C22.8752 8.38135 22.1236 8.69265 21.5695 9.24676C21.0154 9.80088 20.7041 10.5524 20.7041 11.3361Z"
        fill="#EEF4F7"
        stroke="#FB5950"
        strokeWidth="2.97727"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
